/** Decode HTML entities and strip tags in WordPress rendered strings (titles, excerpts). */
export function decodeHtmlEntities(value: string | undefined | null): string {
  if (!value) return '';

  let decoded: string;
  if (typeof document !== 'undefined') {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    decoded = textarea.value;
  } else {
    decoded = value
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/g, "'")
      .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)));
  }

  return decoded.replace(/<[^>]*>/g, '');
}

export function stripHtml(value: string | undefined | null): string {
  return decodeHtmlEntities(value).replace(/\s+/g, ' ').trim();
}
